var map = {
	"./arrow_down.svg": 9361,
	"./codeberg.svg": 8642,
	"./edit.svg": 3195,
	"./heart.svg": 3155,
	"./heart_on.svg": 6155,
	"./reply.svg": 7755,
	"./tip.svg": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5058;